import {info} from "services-comun/modules/browser/log";

import {type IModulo, Modulo} from "./index";
import {ModuloError} from "./error";

export interface IModuloScroll extends IModulo {
    margen?: string;
    visible?: number;
}

export abstract class ModuloScroll<T extends IModuloScroll = IModuloScroll> extends Modulo<T> {
    /* STATIC */
    protected constructor(cfg: T) {
        super({
            margen: "100px",
            visible: 0.0,
            ...cfg,
        });
    }

    protected override async runElement(element: HTMLElement): Promise<void> {
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        new IntersectionObserver((entries, observer)=>{
            entries.forEach(entry=>{
                if (entry.isIntersecting) {
                    this.inViewPort(element).then(()=>{});
                    // observer.unobserve(element);
                }
            });
        }, {
            rootMargin: this.cfg.margen,
            threshold: this.cfg.visible,
        }).observe(element);
    }

    private async inViewPort(element: HTMLElement): Promise<void> {
        let controller = this.controllers.get(element);
        try {
            if (controller == undefined) {
                info(this.nombre, "Obteniendo controlador");
                controller = await this.controller(element);
                this.controllers.set(element, controller);
            }
            if (controller.ejecutando) {
                return;
            }
            info(this.nombre, "Ejecutando");
            await controller.beforeRun();
            await controller.run();
            if (controller.primeraEjecucion) {
                await controller.runOnce();
            }
            await controller.afterRun();
        } catch (err) {
            await controller?.errorRun();
            ModuloError.show(this, err);
        }
    }
}
